(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets-vertical-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const btn = event.target.closest('[data-close-facets-wrapper]');
  if (!btn) return;
  const wrapper = btn.closest('.mobile-facets__wrapper');
  if (wrapper) wrapper.querySelector('summary')?.click();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  if (event.target.closest('[data-close-facets-wrapper]')) {
    const wrapper = event.target.closest('.mobile-facets__wrapper');
    if (wrapper) wrapper.querySelector('summary')?.click();
  }
  if (event.target.closest('[data-close-facet-drawer]')) {
    const drawer = event.target.closest('facet-drawer');
    if (drawer) drawer.querySelector('summary')?.click();
  }
});
  } catch(e) { console.error(e); }
})();

})();
